import { colors as muiColors } from "/vendor/@material-ui/core";
import salmon from "./salmon";
import red from "./red";
import redderRed from "./redderRed";
import appleGreen from "./appleGreen";
import slateBlue from "./slateBlue";
import magenta from "./magenta";
import paynesGrey from "./paynesGrey";
import pistachio from "./pistachio";
import cornflowerBlue from "./cornflowerBlue";
import cyberGrape from "./cyberGrape";
import persianPink from "./persianPink";
import lime from "./lime";
import indigo from "./indigo";
import blue from "./blue";
import pink from "./pink";
import teal from "./teal";
import green from "./green";
import yellow from "./yellow";

export default {
  ...muiColors,
  appleGreen,
  green,
  yellow,
  cornflowerBlue,
  cyberGrape,
  magenta,
  paynesGrey,
  persianPink,
  pistachio,
  salmon,
  slateBlue,
  lime,
  indigo,
  blue,
  pink,
  teal,
  red,
  redderRed,
};
